export const ProductListingTypes = {
	ContainerStack: "container stack",
	TraditionalApplication: "traditional application",
	OpenStackInfrastructure: "openstack infrastructure",
};

export const listingTypeOptions = [
	{
		header: "Containerized",
		value: ProductListingTypes.ContainerStack,
	},
	{
		header: "Standalone",
		value: ProductListingTypes.TraditionalApplication,
	},
	{
		header: "OpenStack",
		value: ProductListingTypes.OpenStackInfrastructure,
	},
];
